export default __webpack_public_path__ + "static/media/installer-step3.390bcec0.jpg";